<template>
<div v-if="isBusy2">
  <b-card >
    <template v-slot:header  >
      <h4 class="mb-0"> <i class="fas fa-edit"></i>   Detalle Personal: {{personal.nombres}}</h4>
    </template>
<vue-snotify></vue-snotify> 
    <b-card-body >
        <b-card header-tag="header"  border-variant="info"  
        >
        <template v-slot:header>
       <h5><i class="fas fa-user-friends"></i> Datos Básicos</h5>
      </template>
 <template v-if="!editar">
     <div role="group"  >
                        <b-row>
                            <!-- <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3">
                               
                                 <h4><b-badge variant="info">Tipo Doc. de Identidad :</b-badge> </h4><select v-model="tipoDocumento" disabled>                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select>
                            </b-col>  -->
                            

                            <b-col  cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                              <h4><b-badge variant="light">Doc. de Identidad :</b-badge>  {{ personal.numero_documento}}</h4>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">                              
                                <h4><b-badge variant="light">Nombres y Apellidos :</b-badge>  {{personal.nombres}}, {{personal.apellido_paterno}} {{personal.apellido_materno}}</h4>
                            </b-col>
                        
                        </b-row><br>
                        <b-row>
                            
                            <!-- <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                               <h2><b-badge variant="info">A. Paterno</b-badge>: </h2>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                                <h2><b-badge variant="info">A. Materno</b-badge>: </h2>
                            </b-col> -->
                        </b-row><br>
                        <b-row>
                            <b-col cols="2"	sm="3"	md="4"	lg="4"	xl="12">
                                
                                <h4><b-badge variant="light">Dirección :</b-badge> {{personal.direccion}}</h4>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col >
                                 <h4><b-badge variant="light">Celular :</b-badge>  {{personal.telefono}}</h4>

                            </b-col>
                            <b-col >    
                               <h4><b-badge variant="light">Empresa :</b-badge>  {{user.cuenta.razonSocial}}</h4>
                            </b-col>
                            <b-col >
                              
                                <h4><b-badge variant="light">Sueldo :</b-badge>  {{personal.sueldo}}</h4>
                            </b-col>
                            
                        </b-row><br>
                     
                    
                    </div>
 

  
                         <div class="text-right">             <b-btn variant="info" size="lg" @click="editaPer()" ><i class="fas fa-user-edit"></i> Editar</b-btn> </div>

</template>
 <template v-else>
      <div role="group"  >
                        <b-row>
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="4">
                                <label >Tipo Doc. de Identidad:</label>
                                <select class="custom-select" id="inlineFormCustomSelect" v-model="tipoDocumento" >                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select> 
                            </b-col>
                            <b-col  cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >Doc. de Identidad:</label>
                                
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-passport"></i></span>
                                    </div>
                                    <b-form-input placeholder="Documento"  v-model="personal.numero_documento"></b-form-input>
                                </b-input-group>
                                
                              
                            </b-col>
                            
                        
                        </b-row><br>
                        <b-row>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >Nombres:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Nombre" v-model="personal.nombres"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >A. Paterno:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Apellido Paterno" v-model="personal.apellido_paterno"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >A. Materno:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Apellido Materno" v-model="personal.apellido_materno"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col cols="2"	sm="3"	md="4"	lg="4"	xl="12">
                                <label >Dirección:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-map-marked-alt"></i></span>
                                    </div>
                                    <b-form-input placeholder="Direccion referencia" v-model="personal.direccion"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                               <label >Celular:</label> 
                               <b-input-group>
                                    
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-phone"></i></span>
                                    </div>
                                    <b-form-input placeholder="Celular" v-model="personal.telefono"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                                <label >Empresa:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-building"></i></span>
                                    </div>
                                    <!-- <b-form-input placeholder="Empresa" v-model="personal.empresa"></b-form-input> -->
                                    <b-form-input
                type="text"
                v-model="user.cuenta.razonSocial"
                readonly>
              </b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                                <label >Sueldo:</label>
                               <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-dollar-sign"></i></span>
                                    </div>
                                    <b-form-input placeholder="Sueldo" v-model="personal.sueldo"></b-form-input>
                                </b-input-group>
                            </b-col>
                            
                        </b-row><br>
                     
                    
                    </div>
                     <div class="text-right">
                                    <b-btn variant="danger" size="lg" @click="editar = false" ><i class="fas fa-window-close"></i> Cancelar</b-btn> 
                                     <b-btn variant="success" size="lg" @click="actualizarPersonal()" ><i class="far fa-save"></i> Guardar</b-btn>
                                </div>
 </template>
 
    </b-card> 
    <b-card header-tag="header" border-variant="success" >
      <template v-slot:header>
        <h5 class="mb-1"><i class="fas fa-business-time"></i> Marcar Asistencia </h5>
      </template>
        <b-card-text><div>

            <b-row  >
                <b-col xl="8"> 
           <b-row>
           
                <b-col><b-button @click="marcarAsistencia('hora_entrada')"  size="lg" pill variant="outline-success"><i class="fas fa-hourglass-start"></i> Entrada</b-button></b-col>
                <b-col><b-button @click="marcarAsistencia('hora_ini_refrigerio')" size="lg" pill variant="outline-info"><i class="fas fa-utensils"></i> Refrigerio</b-button></b-col>
                <b-col><b-button @click="marcarAsistencia('hora_fin_refrigerio')" size="lg" pill variant="outline-info"><i class="fas fa-stopwatch"></i> Fin Refrigerio</b-button></b-col>
                <b-col><b-button @click="marcarAsistencia('hora_salida')" size="lg" pill variant="outline-danger"><i class="fas fa-hourglass-end"></i> Salida</b-button></b-col>
            </b-row>
            </b-col>
                <!-- <b-col xl="4" >
                    <div class="text-right"><router-link :to="'asistencia/' + personal.id"> <b-button size="lg" pill variant="info"><i class="fas fa-history"></i> Ver Reporte</b-button>  </router-link></div>
                    </b-col> -->
                    <b-col xl="4" >
                    <div class="text-right"> <b-button size="lg" @click="listarAsistencia()" pill variant="info"><i class="fas fa-history"></i> Ver Reporte</b-button></div>
                    </b-col>
            </b-row>
</div>
</b-card-text>
      </b-card> 
    </b-card-body>
    
 <template v-if="!asis">
     <div>
   
  <b-card-group deck>

     <b-card header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <h5 class="mb-1"><i class="fas fa-money-check-alt"></i> Bancos</h5>
      </template>
      <b-row> 
        <b-col xl="12" >
                                <label>Banco:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Nombre" v-model="banco.nombre"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col xl="6" >
                                <label >Cuenta:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="cuenta" v-model="banco.numero_cuenta"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            <b-col xl="6">
                                <label >Moneda:</label>
                                <b-input-group>
                                    
                                    <!-- <b-form-input placeholder="moneda" v-model="banco.tipo_moneda"></b-form-input> -->

                                       <b-form-select v-model="banco.tipo_moneda" class="mb-3">
                                        <option >SOLES</option>
                                        <option >DOLARES</option>
                                        <option >EUROS</option>
                                        
                                        </b-form-select>
                                </b-input-group>
                            </b-col>
                        </b-row>
                       <br>
                        <div class="text-right"><b-button  variant="success"  @click="addDetalle(1)" >Añadir Banco</b-button></div>
                        
                      
                       
      
      <br><br>
        <b-row>
                        <b-col>
                                <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                <b-table striped hover  :items="lbancos" :fields="bancos_campos" small>
                                <template slot="acciones" slot-scope="row">
                                    <b-button-group>
                                        <b-button @click="delDetalle(row.item, 'banco')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                    </b-button-group>
                                </template>   
                                </b-table>

                          <div>

                          </div>    
                          
                      
                            </b-col>
                      </b-row>   
    </b-card>

    <b-card header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <h5 class="mb-1"><i class="fa fa-building"></i> Sistema Pensiones</h5>
      </template>
      <b-row> 
       
                            <b-col xl="6" >
                                <label >Régimen:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="régimen" v-model="pension.regimen"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            <b-col xl="6">
                                <label >Código:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="código" v-model="pension.codigo"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                       <br>
                        <div class="text-right"><b-button  variant="success"  @click="addDetalle(2)" >Añadir</b-button></div>
                        
                      
                       
      
      <br><br>
        <b-row>
                        <b-col>
                                <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                <b-table striped hover :items="lpension" :fields="pcampos" >
                                      <template slot="acciones" slot-scope="row">
                                    <b-button-group>
                                        <b-button @click="delDetalle(row.item, 'regimenpension')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                    </b-button-group>
                                </template>   
                                </b-table>   

                          <div>

                          </div>    
                          
                      
                            </b-col>
                      </b-row>   
    </b-card>

     <b-card  header-tag="header">
      <template v-slot:header>
        <h5 class="mb-1"><i class="far fa-hospital"></i> Salud</h5>
      </template>
      <b-row> 
       
                            <b-col xl="6" >
                                <label >Régimen:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="régimen" v-model="salud.regimen"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            <b-col xl="6">
                                <label >Código:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="código" v-model="salud.codigo"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                       <br>
                       <div class="text-right"><b-button  variant="success" @click="addDetalle(3)" >Añadir</b-button></div>
                        
                      
                       
      
      <br><br>
        <b-row>
                        <b-col>
                                <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                <b-table striped hover :items="lsalud" :fields="pcampos" >
                                    <template slot="acciones" slot-scope="row">
                                    <b-button-group>
                                        <b-button @click="delDetalle(row.item, 'regimensalud')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                    </b-button-group>
                                </template>   
                                </b-table> 

                           
                          
                      
                            </b-col>
                      </b-row>
      
    </b-card>

  </b-card-group>
</div>
<br>
<div>
  <b-card-group deck>
   
    <b-card  header-tag="header">
      <template v-slot:header>
       <h5><i class="fas fa-home"></i> Familiares</h5>
      </template>
      <b-row> 
        <b-col xl="6" >
                                <label>Nombres:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Nombre" v-model="familiar.nombres"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col xl="6" >
                                <label >Parentesco:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Parentesco" v-model="familiar.parentesco"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            
                        </b-row><br>
                        <b-row><b-col xl="6">
                                <label >Dirección:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Apellido Materno" v-model="familiar.direccion"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col xl="6">
                                <label >Teléfono:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Direccion referencia" v-model="familiar.telefono"></b-form-input>
                                </b-input-group>
                            </b-col>  </b-row>   
                            <br>   

                            <div class="text-right"><b-button  variant="success" @click="addDetalle(4)" >Añadir</b-button>     </div>            
                            <br>
                          <b-row>
                                <b-col>
                                        <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                        <b-table striped hover :items="lfamiliar" :fields="fcampos" >
                                            <template slot="acciones" slot-scope="row">
                                            <b-button-group>
                                                <b-button @click="delDetalle(row.item, 'familiar')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                            </b-button-group>
                                        </template>   
                                        </b-table> 

                                
                                
                            
                                    </b-col>
                            </b-row>
    </b-card>
     <b-card  header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <h5 class="mb-1"><i class="fas fa-exclamation-circle"></i> Incidencias </h5>
      </template>
      <b-row> 
        
                            <b-col xl="6" >
                                <label >Asunto:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Asunto" v-model="referencia.trabajo_anterior"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            <b-col xl="6">
                                <label >Descripción:</label>
                                <b-input-group>
                                    
                                    <b-form-textarea placeholder="descripción" v-model="referencia.observaciones"></b-form-textarea>
                                </b-input-group>
                            </b-col>
                        </b-row>
                           <br>   

                            <div class="text-right"><b-button  variant="success" @click="addDetalle(4)" >Añadir</b-button>   </div>              
                            <br>
                          <b-row>
                                <b-col>
                                       <!-- <h5><b-badge v-for="(item, index) in lreferencia" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                        <b-table striped hover :items="lreferencia" :fields="rcampos" >
                                            <template slot="acciones" slot-scope="row">
                                            <b-button-group>
                                                <b-button @click="delDetalle(row.item, 'referencia')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                            </b-button-group>
                                        </template>   
                                        </b-table> 

                                
                                
                            
                                    </b-col>
                            </b-row>
    </b-card>
  </b-card-group>
</div>
<br>
<div>
  <b-card-group deck>
   
    <b-card border-variant="primary"  header-tag="header" header-bg-variant="primary"
        header-text-variant="white">
      <template v-slot:header>
       <h5><i class="fas fa-network-wired"></i> Trabajos</h5>
      </template>
       <b-row> 
        <b-col xl="4" >
                                <label>Departamento:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Departamento" v-model="trabajo.departamento"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col xl="4" >
                                <label >Cargo:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Cargo" v-model="trabajo.cargo"></b-form-input>
                                </b-input-group>
                            </b-col> 
                            <b-col xl="3">
                                <label >Teléfono:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Teléfono" v-model="trabajo.telefono" type="tel"></b-form-input>
                                </b-input-group>
                            </b-col>
                        
                            <b-col xl="1">
                                <label >Anexo:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Anexo" v-model="trabajo.anexo" type="number"></b-form-input>
                                </b-input-group>
                            </b-col>  
                            </b-row><br>   
                            <b-row> 
                            <b-col xl="4">
                                <label >Contrato:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Contrato" v-model="trabajo.contrato"></b-form-input>
                                </b-input-group>
                            </b-col>    
                            <br>  
                            <b-col xl="4">
                                <label >Situación Laboral:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Situación Laboral" v-model="trabajo.situacion_laboral"></b-form-input>
                                </b-input-group>
                            </b-col>  </b-row>   
                            <br> 
                            <b-row>
                            <b-col xl="3" >
                                <label >Fecha de Ingreso:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Fecha de Ingreso" v-model="trabajo.fecha_ingreso" type="date" ></b-form-input>
                                </b-input-group>
                            </b-col>    
                            <br> 
                            <b-col xl="3" >
                                <label >Fecha de Cese:</label>
                                <b-input-group>
                                    
                                    <b-form-input placeholder="Fecha de Cese" v-model="trabajo.fecha_cese" type="date" ></b-form-input>
                                </b-input-group>
                            </b-col>     
                            <br> 
                            <b-col  xl="6" >
                                <label >Motivo de cese:</label>
                                <b-input-group>
                                    
                                    <b-form-textarea placeholder="Motivo de cese" v-model="trabajo.motivo_cese"></b-form-textarea>
                                </b-input-group>
                            </b-col>  </b-row>   
                            <br> 

                           <div class="text-right"><b-button  variant="success" @click="addDetalle(5)" >Añadir</b-button>      </div>           
                            <br>
                          <b-row>
                                <b-col>
                                        <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                        <b-table striped hover :items="ltrabajos" :fields="tcampos"  >
                                            <template slot="acciones" slot-scope="row">
                                            <b-button-group>
                                                <b-button @click="delDetalle(row.item, 'trabajo')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                            </b-button-group>
                                        </template>   
                                        </b-table> 

                                
                                
                            
                                    </b-col>
                            </b-row> 
                            
       
      
    </b-card>
  </b-card-group>
</div>   

</template>
<template v-if="asis">
    <b-card border-variant="primary"  header-tag="header" header-bg-variant="info"
        header-text-variant="black">
      <template v-slot:header>
       <h5><i class="fas fa-network-wired"></i> Historial de Asistencia  </h5>
      </template>
       
        
                          <b-row>
                                <b-col>
                                        <!-- <h5><b-badge v-for="(item, index) in lbancos" :key="index" pill variant="secondary"  class="mr-2">{{item}} <i class="fa fa-times borrarcorreo"></i></b-badge></h5> -->
                                        <b-table striped hover :items="lasistencia" :fields="fasistencia" :busy="isBusy3">
                                            <div slot="table-busy" class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong> Listando Asistencia...</strong>
                                            </div>
                                            <!-- <template slot="acciones" slot-scope="row">
                                            <b-button-group>
                                                <b-button @click="delDetalle(row.item, 'trabajo')"  v-b-tooltip.hover variant="danger"><i class="far fa-trash-alt" title="Eliminar Banco"></i></b-button>
                                            </b-button-group>
                                        </template>    -->
                                        </b-table> 

                                
                                
                            
                                    </b-col>
                            </b-row> 
                            
       
      
    </b-card>
</template>


    <template v-slot:footer>
       <div class="text-right">
                                   
                                   <b-button size="lg" variant="danger" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left btnatras"> Volver a Personal</i></b-button>
                                </div>
      </template>
  </b-card>
</div>
    <div  class="col-md-12 text-center" v-else>
                        <h3>Cargando Datos del Colaborador</h3> <br><pulse-loader></pulse-loader>
                    </div>
    
</template>
<script>
import axios from 'axios'
import { DocPersonal } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
export default {
   
      name : 'PersonalNuevo',
      components: {
                        PulseLoader
                    },
      data: () => {
      return {
          isBusy2: false,
          //isBusy3: false,
          editar: false,
          asis: false,
          personal: [],
          tipoDocumento: '01',
          documentosIdentidad: DocPersonal,
          banco: {},
          lbancos: [],
          bancos_campos: [
              {key:'nombre', label: 'Banco'},
              {key:'numero_cuenta', label: '#Cuenta'},
              {key:'tipo_moneda', label: 'Moneda'},
              {key: 'acciones', label: 'Acciones'}
          ],
          pension: {},
          lpension: [],
          pcampos: [
              {key:'regimen', label: 'Regimen'}, 
              {key:'codigo', label: '#Código'},
              {key: 'acciones', label: 'Acciones'}       
          ],
         
           salud: {},
          lsalud: [],

          referencia: {},
          lreferencia: [],
          rcampos: [
              {key:'trabajo_anterior', label: 'Asunto'}, 
              {key:'observaciones', label: 'Descripción'},
              {key: 'acciones', label: 'Acciones'}
                  
          ],
          familiar: {},
          lfamiliar: [],
          fcampos: [
              {key:'nombre', label: 'Nombre'}, 
              {key:'parentesco', label: 'Parentesco'},
              {key:'direccion', label: 'Dirección'}, 
              {key:'telefono', label: 'Teléfono'},
              {key: 'acciones', label: 'Acciones'}
                  
          ],
          trabajo: {},
          ltrabajos: [],
          tcampos: [
              {key:'departamento', label: 'Departamento'}, 
              {key:'cargo', label: 'Cargo'},
              {key:'telefono', label: 'Teléfono'}, 
              {key:'anexo', label: 'Anexo'},
              {key:'contrato', label: 'Contrato'}, 
              {key:'situacion_laboral', label: 'Situación Laboral'},
              {key:'fecha_ingreso', label: 'Fecha Ingreso'}, 
              {key:'fecha_cese', label: 'Fecha de Cese'},
              {key:'motivo_cese', label: 'Motivo de Cese'},
              {key: 'acciones', label: 'Acciones'}
                  
          ],
           lasistencia: [],
           fasistencia: [
              {key:'fecha', label: 'fecha'}, 
              {key:'hora_entrada', label: 'hora entrada'},
              {key:'hora_ini_refrigerio', label: 'hora ini refrigerio'}, 
              {key:'hora_fin_refrigerio', label: 'hora fin refrigerio'},
              {key:'hora_salida', label: 'hora salida'},
              {key:'horas_trabajadas_dia', label: 'horas trabajadas dia'},
              
                  
          ],
          
        //   banco: '',
          
          
          user: {
                    username: '',
                    rol: '',
                    idEmisor: '',
                    cuenta: {
                    razonSocial: '',
                    direccion: {

                    }
                    }
                },
      }

      },

      watch: {
      tipoDocumento: function () {
                if(this.tipoDocumento == '0'){
                    this.sindoc = true
                }else{
                    this.sindoc = false
                }


            },

    },
    mounted () {
        this.userData()
        this.fetchPersonal()
    },
    methods: {
                userData: function () {
                    this.user =  this.$store.getters.userData
                },
                editaPer: function () {
                    this.editar = true
                },

                // nuevoBanco: function (){

                //   this.lbancos.push(this.banco)
                //   //this.initbanco()

                // //   this.banco.nombre = '',
                // //   this.banco.numero_cuenta = '',
                // //   this.banco.tipo_moneda= ''
                // },
            //initbanco:  function() {
             //     this.banco.nombre = '',
              //    this.banco.numero_cuenta = '',
               //   this.banco.tipo_moneda= ''
            //},

                
                
                fetchPersonal: function () {
                //this.isBusy2 = false
                var ide = this.$route.params.id
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/detalle/',{
                    token: this.$store.getters.userToken,
                    id: ide,
                
                })
                .then(response => (
                    this.personal = response.data.response,
                    
                    this.lbancos= response.data.response.bancos,
                    this.lfamiliar= response.data.response.familiares,
                    this.ltrabajos= response.data.response.trabajos,
                    this.lpension= response.data.response.regimenes_pension,
                    this.lsalud= response.data.response.regimenes_salud,
                    this.lreferencia= response.data.response.referencias,
                    

                    this.isBusy2 = true
                    // this.idTercero = value.idTercero,
                    // this.update = true,
                    // this.cargandoDataUpdate = true
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error')
                    this.isBusy2 = false
                })
            },

            //listar asistencia
            listarAsistencia: function () {
                 this.isBusy3 = true
                 this.asis = true
               
                var ide = this.$route.params.id
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/asistencia',{
                    token: this.$store.getters.userToken,
                    id: ide,
                
                })
                .then(response => (
                    this.lasistencia = response.data.response,
                    
                   
                    this.isBusy3 = false
                    // this.idTercero = value.idTercero,
                    // this.update = true,
                    // this.cargandoDataUpdate = true
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error')
                    //this.isBusy2 = false
                })
            },




               actualizarPersonal: function () {
                var ide = this.$route.params.id
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
                    token: this.$store.getters.userToken,
                    id: ide,
                    // tipo_documento: "01",
                    numero_documento: this.personal.documento,
                    nombres: this.personal.nombres,
                    apellido_paterno: this.personal.apellido_paterno,
                    apellido_materno: this.personal.apellido_materno,
                    direccion: this.personal.direccion,
                    telefono: this.personal.telefono,
                    empresa: this.user.idEmisor,
                    sueldo: this.personal.sueldo,
                    
                })
                .then(response => (
                   
                    this.$snotify.success(response.data.msg, 'Éxito'),
                    this.fetchPersonal(),
                     this.editar = false
                ))
                .catch(error => (
                    
                    this.$snotify.error('Error')
                ))
            },
            //marcado de asistencia
            marcarAsistencia: function (value) {
                var ide = this.$route.params.id
                this.isBusy2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/asistencia/insertar', {
                    token: this.$store.getters.userToken,
                    personal: ide,
                    marcado: value
                   
                })
                .then(response => (
                    this.$snotify.success(response.data.msg, 'Marcado Correcto'),
                    this.listarAsistencia()
                ))
                .catch(error => (
                    this.$snotify.error(error.response.data.msg.msg, 'Error'),
                    this.listarAsistencia()
                ))
            },


            //actualizar bancos
            addDetalle: function (tipo) {
                var ide = this.$route.params.id
                // this.isBusy4 = true
                let objeto = {}
                   objeto.token = this.$store.getters.userToken
                   objeto.id= ide
                if (tipo==1){
                   objeto.bancos = [this.banco]
                }
                else if (tipo==2){
                   objeto.regimenes_pension = [this.pension]
                }
                else if (tipo==3){
                    objeto.regimenes_salud = [this.salud]
                }
                else if (tipo==3){
                    objeto.familiares = [this.familiar]
                }
                else if (tipo==4){
                    objeto.referencias = [this.referencia]
                }
                else if (tipo==5){
                    objeto.trabajos = [this.trabajo]
                }
                
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/actualizar',
                    objeto
                    
                   
                    
                )
                .then(response => (
                   
                    this.$snotify.success(response.data.msg, 'Éxito'),
                    //this.isBusy4 = false,
                    this.fetchPersonal()
                ))
                .catch(error => (
                    
                    this.$snotify.error('campos vacios o duplicados ')
                ))
            },
            //actualizar pension
            // addPension: function () {
            //     var ide = this.$route.params.id
            //     axios
            //     .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
            //         token: this.$store.getters.userToken,
            //         id: ide,
                    
            //         regimenes_pension : [this.pension]
                   
                    
            //     })
            //     .then(response => (
                   
            //         this.$snotify.success(response.data.msg, 'Éxito'),
            //         this.fetchPersonal()
            //     ))
            //     .catch(error => (
                    
            //         this.$snotify.error('campos vacios o duplicados')
            //     ))
            // },
            //  //actualizar salud
            // addSalud: function () {
            //     var ide = this.$route.params.id
            //     axios
            //     .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
            //         token: this.$store.getters.userToken,
            //         id: ide,
                    
            //         regimenes_salud : [this.salud]
                   
                    
            //     })
            //     .then(response => (
                   
            //         this.$snotify.success(response.data.msg, 'Éxito'),
            //         this.fetchPersonal()
            //     ))
            //     .catch(error => (
                    
            //         this.$snotify.error('campos vacios o duplicados')
            //     ))
            // },

            // //actualizar bancos
            // addFamilia: function () {
            //     var ide = this.$route.params.id
            //     axios
            //     .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
            //         token: this.$store.getters.userToken,
            //         id: ide,
            //         familiares: [this.familiar],
                   
                    
            //     })
            //     .then(response => (
                   
            //         this.$snotify.success(response.data.msg, 'Éxito'),
            //         this.fetchPersonal()
            //     ))
            //     .catch(error => (
                    
            //         this.$snotify.error('campos vacios o duplicados')
            //     ))
            // },
            //     //actualizar Referencia
            // addReferencia: function () {
            //     var ide = this.$route.params.id
            //     axios
            //     .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
            //         token: this.$store.getters.userToken,
            //         id: ide,
            //         referencias: [this.referencia],
                   
                    
            //     })
            //     .then(response => (
                   
            //         this.$snotify.success(response.data.msg, 'Éxito'),
            //         this.fetchPersonal()
            //     ))
            //     .catch(error => (
                    
            //         this.$snotify.error('campos vacios o duplicados')
            //     ))
            // },
            //   //actualizar trabajos
            // addTrabajo: function () {
            //     var ide = this.$route.params.id
            //     axios
            //     .post(process.env.VUE_APP_API_URL + 'personal/actualizar',{
            //         token: this.$store.getters.userToken,
            //         id: ide,
                    
            //         trabajos : [this.trabajo]
                   
                    
            //     })
            //     .then(response => (
                   
            //         this.$snotify.success(response.data.msg, 'Éxito'),
            //         this.fetchPersonal()
            //     ))
            //     .catch(error => (
                    
            //         this.$snotify.error('campos vacios o duplicados')
            //     ))
            // },
            delDetalle: function (value, valu) {
                swal({
                title: "Seguro de borrar",
                text: "Este proceso no se puede revertir!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                })
                .then((willDelete) => {
                if (willDelete) {
                    this.deleteDetalle(value, valu),
                    this.isBusy4 = true
                }
                });
            },
            deleteDetalle: function (value, valu) {
                this.isBusy4 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/eliminar/detalle', {
                    token: this.$store.getters.userToken,
                    id: value.id,
                    detalle: valu
                   
                })
                .then(response => (
                    this.$snotify.success(response.data.msg, 'Eliminado con Éxito'),
                    this.fetchPersonal()
                ))
                .catch(error => (
                    this.cargando = false,
                    this.isBusy4 = false,
                    this.$snotify.error(error.response.data.msg, 'Error')
                ))
            },
 

    }
    
}
</script>